import {sleep, useMock} from "../utils/helpers";
import http from '../plugins/http';
import config from '../config';

const ratingUri = config.services.rating;

class Coins {
  constructor() {
    this.useMock = useMock('coins');
  }

  async fetchTradingAssets(type) {
    if(this.useMock) {
      return new Promise(async resolve => {
        await sleep(200);
        resolve((await import('../../mock/coins.js')));
      });
    }

    const {data} = await http.get(`${ratingUri}/api/v1/trading/assets?type=${type}`);

    return data.data;
  }

}

export default new Coins();



// WEBPACK FOOTER //
// ./src/services/coins.js